import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import CharacterOfPainTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditCharacterOfPain from "./components/EditCharacterOfPain";
import TableAction from "../../../../components/Table/Actions/ActionDropdown";
import AddCharacterOfPain from "./components/AddCharacterOfPain";
import UploadCSV from "components/uploadCSV";
import ShowModal from "components/Modal/ShowModal";
import SearchBox from "components/Filters/SearchBox";
import { Tag } from "antd";

const Index = () => {
  const columns = [
    {
      title: "Name",
      render: (record) => <span>{record.characterOfPainName}</span>,
      key: "symptomName",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_CharacterOfPain_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteCharacterOfPain"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="characterOfPainList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this character of pain?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>Character of pain</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654280567934-characterOfPainName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getCharacterOfPain"
              recordName="characterOfPainList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getCharacterOfPain"
              url="bulkImportSkills"
              table="CharacterOfPain"
              recordName="characterOfPainList"
              cb="characterOfPainName"
              uId="characterId"
            />
            <AddCharacterOfPain />
          </div>
        }
      >
        <CharacterOfPainTable
          apiName="getCharacterOfPain"
          recordName="characterOfPainList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditCharacterOfPain />
    </Layout>
  );
};
export default Index;
